var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"toast",class:_vm.classes},[_c('p',[_vm._v(_vm._s(_vm.toastState.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }